{
  "admin-hub.adminhub-performance-monitoring-first-run.body-0.non-final": [
    {
      "type": 0,
      "value": "Summary cards for load times, user setup, and your largest apps. Each one links through to the detail."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-1.non-final": [
    {
      "type": 0,
      "value": "Performance bands and percentile trends, over the time range you choose."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-2.non-final": [
    {
      "type": 0,
      "value": "Browser, network, and region data. Filter by product or site to find what's slowing people down."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-3.non-final": [
    {
      "type": 0,
      "value": "Sort to find the slowest, then open a row for P50 and P75 load times."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.button-back.non-final": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.button-done.non-final": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.button-next.non-final": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-0.non-final": [
    {
      "type": 0,
      "value": "Start here"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-1.non-final": [
    {
      "type": 0,
      "value": "See how fast pages load"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-2.non-final": [
    {
      "type": 0,
      "value": "Check the user's side"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-3.non-final": [
    {
      "type": 0,
      "value": "Compare apps and sites"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.step-count.non-final": [
    {
      "type": 1,
      "value": "step"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.action.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.action.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.action.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step-counter": [
    {
      "type": 1,
      "value": "current"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step1.body": [
    {
      "type": 0,
      "value": "View active incidents, maintenance events and their details."
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step1.heading": [
    {
      "type": 0,
      "value": "Track current events"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step2.body": [
    {
      "type": 0,
      "value": "Search and filter past incidents and maintenance events."
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step2.heading": [
    {
      "type": 0,
      "value": "Browse event history"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step3.body": [
    {
      "type": 0,
      "value": "View which app experiences across app instances are currently impacted."
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step3.heading": [
    {
      "type": 0,
      "value": "Check experience status"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step4.body": [
    {
      "type": 0,
      "value": "Get an overview of how events affect your apps and their experiences."
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step4.heading": [
    {
      "type": 0,
      "value": "Review impact on apps"
    }
  ],
  "aviator.service-health-dashboard.spotlight.action.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "aviator.service-health-dashboard.spotlight.action.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "aviator.service-health-dashboard.spotlight.action.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "aviator.service-health-dashboard.spotlight.step-counter": [
    {
      "type": 1,
      "value": "current"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "aviator.service-health-dashboard.spotlight.step1.body": [
    {
      "type": 0,
      "value": "View the current status and recent events for each app in your organization."
    }
  ],
  "aviator.service-health-dashboard.spotlight.step1.heading": [
    {
      "type": 0,
      "value": "Dive into app status"
    }
  ],
  "aviator.service-health-dashboard.spotlight.step2.body": [
    {
      "type": 0,
      "value": "Stay informed about incidents and maintenance events in your organization"
    }
  ],
  "aviator.service-health-dashboard.spotlight.step2.heading": [
    {
      "type": 0,
      "value": "Subscribe to updates"
    }
  ]
}